import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import AssetsCreditDetailsRepayment from '../../components/assets-details-wrapper/assets-credit-details-repayment';
import AppPageMain from '../../modules/app-page/app-page--main';
import PageHeader from '../../modules/page-header';
import { RootState } from '../../types';

const CreditDetailsRepaymentPage: FC = () => {
  const history = useHistory();
  const asset = useSelector(
    (state: RootState) => state.creditDetails.data.details
  );

  return (
    <AppPageMain>
      <div className="container">
        <div className="row">
          <div className="col-19 col-lg-27 col-xl-35">
            <PageHeader
              items={[
                { link: '/assets', title: 'Активы' },
                { link: '/assets', title: 'Займы' },
              ]}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-19 col-lg-27 col-xl-35">
            <AssetsCreditDetailsRepayment
              onClose={() => history.push('/assets')}
              asset={asset}
            />
          </div>
        </div>
      </div>
    </AppPageMain>
  );
};

export default CreditDetailsRepaymentPage;
